const fromInput = (event: KeyboardEvent) => event.target instanceof HTMLInputElement;

export { fromInput };
